import { autoserialize, autoserializeAs } from 'cerialize';

import { BaseDTO, IBaseDTO } from './base-dto';
import { Contact } from './contact';
import { IPartner, Partner } from './partner';
import { ITruckMeta, TruckMeta } from './truck-meta';

export class Truck extends BaseDTO implements ITruck {
  @autoserialize id?: string;
  @autoserializeAs('partner_id') partnerId?: string | null;
  @autoserializeAs('created_at') createdAt?: string | null;
  @autoserializeAs('updated_at') updatedAt?: string | null;
  @autoserializeAs('discarded_at') discardedAt?: string | null;
  @autoserializeAs('licence_plate') licensePlate: string;
  @autoserializeAs('vehicle_type') vehicleType: string;
  @autoserialize override name: string;
  @autoserialize make: string;
  @autoserialize model: string;
  @autoserialize size: string;
  @autoserialize meta?: TruckMeta | null;
  @autoserialize partner?: Partner | null;
  @autoserialize lat?: number | null;
  @autoserialize lng?: number | null;
  @autoserializeAs('central_point_latitude') centralPointLat?: number | null;
  @autoserializeAs('central_point_longitude') centralPointLng?: number | null;
  @autoserializeAs('last_call_radius') lastCallRadius?: number | null;
  centralPointLngLat?: [number, number] | null;
  @autoserialize length?: number | null;
  @autoserialize width?: number | null;
  @autoserialize height?: number | null;
  @autoserialize weight?: number | null;
  @autoserializeAs(Contact, 'driver_contact') driverContact?: Contact | null;

  constructor(payload?: ITruck) {
    super(payload);
    this.id = payload?.id?.toString();
    this.createdAt = payload?.createdAt;
    this.updatedAt = payload?.updatedAt;
    this.discardedAt = payload?.discardedAt;
    this.licensePlate = payload?.licensePlate || '';
    this.name = payload?.name || '';
    this.make = payload?.make || '';
    this.model = payload?.model || '';
    this.size = payload?.size || '';
    this.vehicleType = payload?.vehicleType || '';
    this.meta = payload?.meta ? new TruckMeta(payload.meta) : undefined;
    this.partner = payload?.partner ? new Partner(payload.partner) : undefined;
    this.lat = payload?.lat;
    this.lng = payload?.lng;
    this.centralPointLat = payload?.centralPointLat;
    this.centralPointLng = payload?.centralPointLng;
    this.lastCallRadius = payload?.lastCallRadius;
    this.length = payload?.length ?? undefined;
    this.width = payload?.width ?? undefined;
    this.height = payload?.height ?? undefined;
    this.weight = payload?.weight ?? undefined;
    this.partnerId = payload?.partnerId?.toString() || this.partner?.id;
    this.driverContact = payload?.driverContact ? new Contact(payload.driverContact) : undefined;

    if (this.centralPointLng && this.centralPointLat) {
      this.centralPointLngLat = [this.centralPointLng, this.centralPointLat];
    }
  }
}

export interface ITruck extends IBaseDTO {
  id?: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  licensePlate: string;
  name: string;
  make: string;
  model: string;
  size: string;
  vehicleType: string;
  meta?: ITruckMeta | null;
  partner?: IPartner | null;
  lat?: number | null;
  lng?: number | null;
  centralPointLat?: number | null;
  centralPointLng?: number | null;
  lastCallRadius?: number | null;
  length?: number | null;
  width?: number | null;
  height?: number | null;
  weight?: number | null;
  discardedAt?: string | null;
  partnerId?: string | null;
  driverContact?: Contact | null;
}
